import { Injectable } from '@angular/core';
import { RequestOptions, Response } from '@angular/http';

import { AuthHttp } from '../../../common/index';
import { AppSettings } from '../../../settings/index';

@Injectable()
export class ContainerSizeService {
    constructor(private http: AuthHttp) { }

    get() {
        return this.http.get(AppSettings.apiEndpoint + 'ContainerSize/Get')
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/master/hm/container-size.service.ts